import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ConfiguracaoResponse } from '../../responses/scanntech/configuracao.response';
import { ReturnStruct } from '../../structs/return.struct';
import { ConfiguracaoRequest } from '../../requests/scanntech/configuracao.request';

@Injectable({
  providedIn: 'root',
})
export class ConfiguracaoService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public get(): Observable<ConfiguracaoResponse> {
    return this.httpClient
      .get<ConfiguracaoResponse>(environment.urlApiScanntech + 'Configuracao', this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public post(configuracaoRequest: ConfiguracaoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(
        environment.urlApiScanntech + 'Configuracao',
        configuracaoRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public put(idConfiguracao: number, configuracaoRequest: ConfiguracaoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(
        environment.urlApiScanntech + `Configuracao/idConfiguracao/${idConfiguracao}`,
        configuracaoRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
